import { GraphPosition } from '@arcxgame/contracts/dist/arc-types/core'
import ArcNumber from '@arcxgame/contracts/dist/src/utils/ArcNumber'
import { Erc20Details } from '@arcxmoney/arcx-react'
import { BigNumber, BigNumberish, constants } from 'ethers'
import { Synth } from 'src/services/GraphService'
import { BASE } from '../constants/crypto'

export interface LiquidationDelta {
  collateralAtRisk: BigNumberish
  collateralReward: BigNumberish
  liquidatorRequirement: BigNumberish
}

export function calculateLiquidationDetails(
  position: GraphPosition,
  currentPrice: BigNumberish,
  synth: Synth,
  erc20Details?: Erc20Details,
): LiquidationDelta {
  if (
    !position ||
    !currentPrice ||
    !synth ||
    synth.collateralRatio.eq(0) ||
    BigNumber.from(currentPrice).eq(0) ||
    !erc20Details
  ) {
    return {
      collateralAtRisk: 0,
      collateralReward: 0,
      liquidatorRequirement: 0,
    }
  }

  let liquidationPrice: BigNumber
  const totalLiquidationCut: BigNumber = synth.liquidationUserFee.mul(3).div(2)

  // The ratio of the price of collateral asset will be price * (1 - liquidation spread)
  // This effectively means the synthetic asset is priced higher meaning MORE collateral will be wiped out
  liquidationPrice = ArcNumber.new(1).sub(totalLiquidationCut)

  // Calculate liquidation price for calculations
  liquidationPrice = BigNumber.from(currentPrice).mul(liquidationPrice).div(BASE)

  const collateralNeeded = BigNumber.from(position.borrowedAmountValue)
    .mul(synth.collateralRatio)
    .div(liquidationPrice)

  // let borrowDifference = BigNumber.from(position.borrowedAmountValue).sub(
  //   borrowAllowed
  // );

  // console.log(`Borrow difference: ${borrowDifference.toString()}`);

  let collateralAtRisk: BigNumber

  // The collateral that is at risk is simply your borrow difference converted back to the collateral
  // Since we're using the liquidation price this will include a margin but it is needed so if the price
  // Falls there is time
  collateralAtRisk = collateralNeeded.sub(
    BigNumber.from(position.collateralAmountValue)
      .mul(constants.WeiPerEther)
      .div(BigNumber.from(10).pow(erc20Details.decimals)),
  )

  collateralAtRisk = collateralAtRisk.mul(ArcNumber.new(1).add(totalLiquidationCut)).div(BASE)

  const collateralReward: BigNumber = collateralAtRisk.mul(currentPrice).div(BASE)

  const borrowNeeded = collateralAtRisk.mul(liquidationPrice).div(BASE)
  // collateralReward = collateralAtRisk.sub(collateralReward);

  return {
    collateralAtRisk,
    collateralReward,
    liquidatorRequirement: borrowNeeded,
  } as LiquidationDelta
}
